import {Component, OnDestroy, OnInit} from '@angular/core';

@Component({
    selector: 'app-alumni-connect',
    templateUrl: './alumni-connect.component.html',
    styleUrls: ['./alumni-connect.component.scss']
})
export class AlumniConnectComponent implements OnInit, OnDestroy {
    slides = [
        {image: 'assets/img/alumni-connect/alumni-connect1.webp'},
        {image: 'assets/img/alumni-connect/alumni-connect2.webp'}
    ];
    currentSlide = 0;
    currentStorySlide = 0;
    private intervalId: any;
    stories = [
        {
            name: 'Abhishek Bhatia',
            qualification: 'B.Tech – Civil',
            position: 'Assistant Engineer, Jal Shakti Vibhag',
            location: 'Sub Division Nagrota Bhawan, Distt. Kangra',
            image: 'assets/img/success-stories/abhishek-bhatia.webp',
            description: `<p class="my-2">Abhishek Bhatia is a proud example of ARNI University’s mission to serve the nation by educating its youth. Today, he serves as an Assistant Engineer in the Jal Shakti Vibhag, where he plays a crucial role in developing and maintaining water infrastructure across Himachal Pradesh.</p> <p class="my-2">His work contributes directly to enhancing rural water supply systems, ensuring clean drinking water access, and strengthening the backbone of the state's development.</p><p class="my-2">His journey from a dedicated student to a government officer illustrated the values of service, dedication, and discipline, and we hope this achievement inspires many budding engineers to pursue worthwhile and impactful careers within civil engineering.</p>`,
        },
        {
            name: 'Barun Sharma',
            qualification: 'B-Tech Mechanical Engineer',
            position: 'Junior Assistant, Public Works Department',
            location: 'Jammu',
            image: 'assets/img/success-stories/barun-sharma.webp',
            description: `<p class="my-2">Barun's journey is a testament to hard work and determination. when Barun attained his B.Tech (Mechanical Engineering) from ARNI University, he was laser-focused on public service.</p><p class="my-2"> The academic grounding and support he received from ARNI was invaluable for cracking various competitive exams, which led him to the public works department.
</p><p class="my-2">Today, he serves as a government engineer, contributing meaningfully to the planning and execution of infrastructure projects that impact thousands of lives. His role demands not just technical expertise, but also leadership, responsibility, and a sense of social duty. He demonstrates a commitment to creating a better world for society.</p>
</p>`,
        },
        {
            name: 'Waseem Akram',
            qualification: 'M-Tech in Civil',
            position: 'Technical Officer',
            location: 'Shree Cement Ltd.',
            image: 'assets/img/success-stories/waseem-akram.webp',
            description: `<p class="my-2">Waseem Akaram has always believed in constructing things that will endure. With an M.Tech in Civil Engineering from ARNI University, he not only gained book knowledge but also practical skills that equipped him for the industry.</p><p class="my-2">Whether it was site analysis, material science, or project management, Waseem showed unwavering commitment to mastering every aspect of his discipline.
</p><p class="my-2">Today, he works as a Technical Officer at Shree Cement Ltd., one of the largest cement manufacturers in India. His transformation from an inquisitive learning student to an employee reflects ARNI’s commitment to practical learning and career readiness. Waseem is the embodiment of passion, study, and success.
</p>
</p>`,
        },
        {
            name: 'Pradeep Singh',
            qualification: 'B-Tech Mechanical',
            position: 'Mechanical Engineer',
            location: 'IIT Jammu',
            image: 'assets/img/success-stories/pradeep-singh.webp',
            description: `<p class="my-2">Pradeep Singh's journey from ARNI University to becoming a Mechanical Engineer at IIT Jammu is truly inspiring. His time at ARNI was characterized by hard work, natural curiosity, and a persistent desire to improve.</p><p class="my-2">The excellent mentorship from ARNI faculty and the solid technical starting point awarded him the confidence and ability to reach new levels of academic and professional success.
</p><p class="my-2">Today, Pradeep Singh contributes meaningfully as a Mechanical Engineer at IIT Jammu, where he applies his technical knowledge to cutting-edge research and developmental projects. His success is not just a personal milestone but also a beacon of hope and inspiration for other ARNI students who dare to dream big.</p>
</p>`,
        },
        {
            name: 'Mukul Guleria',
            qualification: 'B.Tech Civil Engineering',
            position: 'Junior Engineer Civil at HPSIDC',
            location: '',
            image: 'assets/img/success-stories/mukul-guleria.webp',
            description: `<p class="my-2">Mukul Guleria’s successful career is an example of hard work and dedication. Mukul is always fascinated by building structures and designing. Therefore, he enrolled in B.Tech Civil Engineering at ARNI University to turn his passion into a profession.</p><p class="my-2">With easy access to well-equipped laboratories, expert mentors, and real-world project exposure at ARNI, he built strong technical skills and problem-solving abilities.
</p><p class="my-2">Mukul's passion for social work and ARNI's guidance led him to HPSIDC as a Junior Engineer, where he manages key infrastructure projects. His journey inspires ARNI students to dream big, work hard, and serve with purpose.
</p>`,
        },
        {
            name: 'Bhawna',
            qualification: 'MBA',
            position: 'Sales Executive at ARMANI Exchange Jalandhar',
            location: '',
            image: 'assets/img/success-stories/bhawna.webp',
            description: `<p class="my-2">Bhawna was always eager to contribute to the business world with her exceptional skills. Her goal to make the shopping experience better for customers lands her at ARNI’s MBA Course, where she develops a strong foundation in business and management.</p><p class="my-2">After completing her MBA from ARNI University, she immediately joined ARMANI Exchange in Jalandhar as a Sales Executive.
</p><p class="my-2">Today, she is excelling in the world of fashion retail, confidently representing a global brand and proving how ARNI empowers its students with both confidence and capability. She stands as a proud ambassador of ARNI University’s mission—to prepare industry-ready professionals who can lead with vision, passion, and purpose.</p>`,
        },
        {
            name: 'Geetika Katoch',
            qualification: 'MBA in HR',
            position: 'HR Assistant, HITECH Engineering Industry, Malot',
            location: '',
            image: 'assets/img/success-stories/geetika-katoch.webp',
            description: `<p class="my-2">A strong motivation to work in a corporate setup and manage people, Geetika Katoch pursued an MBA in HR from ARNI University. During her course, she was mentored by experienced faculty and engaged in live HR projects that built her core competencies.</p><p class="my-2">With the help of ARNI’s placement cell, she got an opportunity to work as an HR Assistant in HITECH Engineering Industry, Malot.
</p><p class="my-2">Geetika proudly credits ARNI University not only for her academic development but also for helping her grow personally and professionally. She learned to lead with empathy, tackle challenges with emotional maturity, and approach each task with a sense of responsibility and purpose.</p>`,
        },
        {
            name: 'Mahesh Kumar',
            qualification: 'Diploma in Mechanical Engineering',
            position: 'MES Army, Supervisor',
            location: '',
            image: 'assets/img/success-stories/mahesh-kumar.webp',
            description: `<p class="my-2">Mahesh Kumar’s journey is a perfect example of how dedication and relevant education lead to professional success without worrying about the duration of the course.</p><p class="my-2">Ever since he completed his Diploma in Mechanical Engineering from ARNI University, he has stepped into a challenging role with MES (Military Engineer Service) Army as a supervisor.</p><p class="my-2">Today, Mahesh manages critical tasks in a disciplined environment, where he applies his skills with confidence. He remains a proud alumnus of ARNI University, frequently crediting his alma mater for giving him a strong foundation, real-world readiness, and a launchpad into a career that truly aligns with his values.</p>`,
        },
        {
            name: 'Irfah Ayoub',
            qualification: 'M.Sc. Botany',
            position: 'Teacher at Ghayas Model School, Jammu',
            location: '',
            image: 'assets/img/success-stories/irfah-ayoub.webp',
            description: `<p class="my-2">The spirit of spreading education and infusing knowledge among the students is the only goal IRFAH Ayoub has. Therefore, she turned her academic excellence into a meaningful career by choosing to teach and inspire the new generation.</p><p class="my-2">She completed her M. Sc. In Botany from ARNI University to enhance her knowledge base, aiming for this specialization.
</p><p class="my-2">She took up a teaching role at Ghayas Model School in Jammu, her story reflects how ARNI nurtures not just careers, but the future educators and changemakers of tomorrow. ARNI University is honored to have been a part of Irfah’s transformative journey and continues to stand by its commitment to nurturing educators, leaders, and socially conscious citizens.</p>`,
        },
        {
            name: 'Sunehal Rehalia',
            qualification: 'M.Sc. Chemistry',
            position: 'Chemist at Cadila Pharmaceuticals, Jammu & Kashmir',
            location: '',
            image: 'assets/img/success-stories/sunehal-rehalia.webp',
            description: `<p class="my-2">Sunehal Rehalia’s academic dedication and love for chemistry led him to a professional role at Cadila Pharmaceuticals, one of the reputed names in the pharmaceutical sector.</p><p class="my-2">He has done his M.Sc. Chemistry from ARNI University, his time at ARNI included extensive lab sessions, industry-oriented projects, and mentorship that made complex concepts simpler and application-ready.
</p><p class="my-2">Today, Sunehal proudly serves as a chemist at Cadila Pharmaceuticals, one of India’s leading pharmaceutical companies. In his role, he is actively involved in formulation development, quality assurance, and innovation in drug manufacturing, making a real difference in people’s lives through his work in medicine and healthcare.
</p>`,
        },
        {
            name: 'Nitin Choudhary',
            qualification: 'B. Tech Mechanical',
            position: 'Indian Army',
            location: '',
            image: 'assets/img/success-stories/nitin-choudhary.webp',
            description: `<p class="my-2">Discipline, strength, and knowledge define Nitin Choudhary’s inspiring journey. After earning his B.Tech in Mechanical Engineering from ARNI University, he took the proud step of joining the Indian Army.</p><p class="my-2">At ARNI, he built a strong base in technical studies, problem-solving, and leadership—skills that are now part of his daily routine in service.</p><p class="my-2">Nitin’s story shows how ARNI doesn’t just prepare students for jobs—it shapes individuals who are ready to serve the country with integrity and courage. Today, as he stands proudly in uniform, Nitin reflects on how the values instilled in him at ARNI University continue to guide him, fueling his passion for serving his country and making a difference in the world.</p>`,
        },
        {
            name: 'Latu Pathania',
            qualification: 'M.Sc Chemistry',
            position: 'Chairperson, Universal Coaching Institute, Solan',
            location: '',
            image: 'assets/img/success-stories/latu-pathania.webp',
            description: `<p class="my-2">With a mission to educate and uplift, Latu Pathania transformed her academic journey into a leadership role in education.</p><p class="my-2">After completing her M.Sc. in Chemistry from ARNI University, she founded the Universal Coaching Institute in Solan, where she now serves as Chairperson. Her time at ARNI was filled with learning, mentorship, and personal growth.</p><p class="my-2">Latu’s success is a true reflection of the transformative power of education, the entrepreneurial drive that ARNI instills, and her relentless pursuit of her dreams. She continues to inspire students and educators alike, proving that with passion, hard work, and a vision to uplift others, one can achieve greatness and create positive change in society.
</p>`,
        },
    ];
    newsroomItems = [
        {
            title: 'Admissions To Phd. Programme',
            date: '02 Apr 2025'
        },
        {
            title: 'Scholarship Upto 100%',
            date: '02 Apr 2025'
        },
        {
            title: 'Programs Offered',
            date: '02 Apr 2025'
        },
    ];
    events = [
        {
            title: 'International Conference on Cross Multi-Disciplinary Approaches to Global Challenges',
            date: 'Dec 26–28, 2024'
        },
        {
            title: 'Annual Alumni Meet',
            date: 'Apr 25, 2025'
        },
        {
            title: 'Tech Talk Series with Industry Experts',
            date: 'May 10, 2025'
        },
        {
            title: 'Arni Cultural Fest',
            date: 'June 2, 2025'
        }
    ];

    jobs = [
        {
            title: 'Professor – Computer Science & Engineering at Arni University',
            time: '1 Week ago'
        },
        {
            title: 'Assistant Professor – Law at Arni University',
            time: '1 Week ago'
        },
        {
            title: 'Medical Laboratory Technician at Arni University',
            time: '2 Weeks ago'
        },
    ];


    squareImages = [
        'assets/img/alumni-connect/alumni/alumni1.webp',
        'assets/img/alumni-connect/alumni/alumni2.webp',
        'assets/img/alumni-connect/alumni/alumni3.webp',
        'assets/img/alumni-connect/alumni/alumni4.webp',
        'assets/img/alumni-connect/alumni/alumni5.webp',
        'assets/img/alumni-connect/alumni/alumni6.webp',
        'assets/img/alumni-connect/alumni/alumni7.webp',
        'assets/img/alumni-connect/alumni/alumni8.webp',
        'assets/img/alumni-connect/alumni/alumni9.webp',
        'assets/img/alumni-connect/alumni/alumni10.webp',
        'assets/img/alumni-connect/alumni/alumni11.webp',
        'assets/img/alumni-connect/alumni/alumni12.webp',
        'assets/img/alumni-connect/alumni/alumni13.webp',
        'assets/img/alumni-connect/alumni/alumni14.webp',
        'assets/img/alumni-connect/alumni/alumni15.webp',
        'assets/img/alumni-connect/alumni/alumni16.webp',
        'assets/img/alumni-connect/alumni/alumni17.webp',
        'assets/img/alumni-connect/alumni/alumni18.webp',
        'assets/img/alumni-connect/alumni/alumni19.webp',
        'assets/img/alumni-connect/alumni/alumni20.webp',
    ];


    constructor() {
    }

    ngOnInit(): void {
        this.startAutoplay()
    }

    nextSlide() {
        if (this.currentStorySlide < this.stories.length - 1) {
            this.currentStorySlide++;
        }
    }

    prevSlide() {
        if (this.currentStorySlide > 0) {
            this.currentStorySlide--;
        }
    }

    startAutoplay() {
        this.intervalId = setInterval(() => {
            this.currentSlide = (this.currentSlide + 1) % this.slides.length;
        }, 5000); // 5 seconds
    }

    goToSlide(index: number) {
        this.currentSlide = index;
    }

    ngOnDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }

}
